import Vue from 'vue'
import AjaxCart from '../helpers/AjaxCart'
import Helpers from '../helpers/Helpers'

class SideCart {
    constructor (theme, elem) {
        this.theme = theme
        this.elem = elem
        this.vue = null
    }
    async onInit () {
        const _cart = await AjaxCart.getCart()
        const _giftWrapInfo = JSON.parse(this.elem.querySelector('[data-gift-wrap]').innerHTML)
        let giftwrapStatus = false
        if (_cart.data.attributes.giftwrap === 'yes') {
            giftwrapStatus = true
        }
        this.vue = new Vue({
            el: '.side-cart',
            data: {
                cart: _cart.data || null,
                giftwrap: giftwrapStatus,
                giftWrapInfo: _giftWrapInfo,
                needsUpdate: false
            },
            mounted: function () {
                const cartOpens = document.querySelectorAll('[data-cart-open]')
                if (cartOpens.length > 0) {
                    for (let button of cartOpens) {
                        button.addEventListener('click', e => {
                            e.preventDefault()
                            this.openCart()
                        })
                    }
                }
                const cartCloses = document.querySelectorAll('[data-cart-close]')
                if (cartCloses.length > 0) {
                    for (let button of cartCloses) {
                        button.addEventListener('click', () => {
                            this.closeCart()
                        })
                    }
                }
                this.$el.addEventListener('mousedown', e => {
                    e.stopPropagation()
                    if (e.target === e.currentTarget) {
                        this.closeCart()
                    }
                })
                document.addEventListener('cartItemAdded', () => {
                    this.updateCart()
                    this.openCart()
                })
            },
            filters: {
                money: (n) => {
                    return Helpers.formatMoney(n)
                }
            },
            methods: {
                updateCart: async function () {
                    let payload = {}
                    this.needsUpdate = false
                    let current = await AjaxCart.getCart()
                    for (let item of current.data.items) {
                        payload[item.key] = item.quantity
                    }
                    if (payload) {
                        const _cart = await AjaxCart.updateItems(payload)
                        if (_cart.status === 200) {
                            this.cart = _cart.data
                        }
                    }
                },
                removeItem: async function (item) {
                    item.quantity = 0
                    item.removed = true
                    await AjaxCart.removeItem(item.id)
                    this.updateCart()
                },
                handleChange: async function (item, i) {
                    this.needsUpdate = true
                    let id = item.variant_id
                    let quantity = item.quantity + i
                    let payload = '{' + id + ': ' + quantity + '}'
                    item.quantity = quantity
                    await AjaxCart.updateItems(payload)
                    payload = {}
                    this.needsUpdate = false
                    for (let item of this.cart.items) {
                        payload[item.key] = item.quantity
                    }
                    if (payload) {
                        const _cart = await AjaxCart.updateItems(payload)
                        if (_cart.status === 200) {
                            this.cart = _cart.data
                        }
                    }
                    this.updateCart()
                },
                openCart: function () {
                    this.$el.classList.add('side-cart-open')
                    document.querySelector('body').classList.add('no-scroll')
                    document.querySelector('header.site-header').classList.add('side-cart-open')
                },
                closeCart: function () {
                    this.$el.classList.remove('side-cart-open')
                    document.querySelector('body').classList.remove('no-scroll')
                    document.querySelector('header.site-header').classList.remove('side-cart-open')
                },
                toggleCart: function () {
                    if (this.$el.classList.contains('side-cart-open')) {
                        this.closeCart()
                    } else {
                        this.openCart()
                    }
                },
                itemImage: function (src) {
                    return Helpers.getSizedImageUrl(src, '84x118_crop_center')
                },
                addGiftWrap: async function () {
                    var payload = {quantity: 1, id: this._data.giftWrapInfo.id, properties: {giftwrap: true}, attributes: {giftwrap: 'yes'}}
                    await AjaxCart.addItem(payload)
                    this.giftwrap = true
                    this.updateCart()
                },
                removeGiftWrap: async function () {
                    await AjaxCart.removeItem(this._data.giftWrapInfo.id)
                    var payload = {attributes: {giftwrap: 'no'}}
                    await AjaxCart.changeAttribute(payload)
                    this.giftwrap = false
                    this.updateCart()
                },
                toggleClass: function (elem, classToAdd) {
                    document.querySelector(elem).classList.toggle(classToAdd)
                }
            }
        })
        window.vueJob = this.vue
    }
}

export default SideCart



// WEBPACK FOOTER //
// ./src/resources/scripts/components/SideCart.js